import type { TFunction } from 'i18next'

export const validateName = (
  value: string,
  t: TFunction,
  minLength: number,
  maxLength: number
) => {
  if (value === '') {
    return ''
  }

  if (value.startsWith(' ')) {
    return t('noLeadingSpaceAllowed')
  }

  if (value.trim().length < minLength) {
    return t('fieldTooShort', { minLength })
  } else if (value.trim().length > maxLength) {
    return t('fieldTooLong', { maxLength })
  }

  return ''
}

export function toNumber(value: number | string): number {
  if (typeof value === 'number') {
    return value
  }

  // Remove non-numeric characters except for the decimal point and minus sign
  const cleanedStr = value.replace(/[^0-9.-]+/g, '')

  return Number.parseFloat(cleanedStr)
}
